import usePusher from 'hooks/usePusher';
import { useEffect } from 'react';
import useRevenuesFilesUploadStore from './useRevenuesFilesUploadStore';

const useCleanRevenuesFileStore = () => {
  const channel = usePusher();

  useEffect(() => {
    if (!channel) return;

    const handler = (event: { data: { _id: string } }) => {
      const id = event?.data?._id;
      if (!id) return;
      const invoices = useRevenuesFilesUploadStore.getState()['invoice'];
      const creditNotes = useRevenuesFilesUploadStore.getState()['credit-note'];

      const invoiceFile = invoices
        .getValues()
        .find((fileState) => fileState.result === id);
      if (invoiceFile) return invoices.remove(invoiceFile.key);

      const creditNoteFile = creditNotes
        .getValues()
        .find((fileState) => fileState.result === id);
      if (creditNoteFile) return creditNotes.remove(creditNoteFile.key);
    };

    channel.bind('revenue.deleted', handler);
    return () => {
      channel.unbind('revenue.deleted', handler);
    };
  }, [channel]);
};

export default useCleanRevenuesFileStore;
